
import React from "react";
import { Button } from "@/components/ui/button";
import { Brain, Sparkles, Calculator, Text } from "lucide-react";
import { MiniGameConfig } from "../MiniGame";
import { miniGames } from "./miniGamesConfig";

interface BrainBreaksProps {
  onPlayGame: (game: MiniGameConfig) => void;
}

const BrainBreaks: React.FC<BrainBreaksProps> = ({ onPlayGame }) => {
  return (
    <div className="bg-muted/50 rounded-lg p-4 border">
      <div className="flex items-start mb-3">
        <Brain className="h-5 w-5 mr-2 text-indigo-500 flex-shrink-0 mt-0.5" />
        <h3 className="font-medium">Brain Breaks</h3>
      </div>
      
      <p className="text-sm text-muted-foreground ml-7 mb-4">
        Take a quick mental break with these focus-boosting activities
      </p>
      
      {/* Game buttons */}
      <div className="flex flex-wrap gap-3 ml-7">
        {miniGames.map((game) => {
          // Select icon and color based on game type
          let GameIcon;
          let iconColor;
          
          if (game.id === "memory-match") {
            GameIcon = Sparkles;
            iconColor = "text-amber-500";
          } else if (game.id === "quick-math") {
            GameIcon = Calculator;
            iconColor = "text-blue-500";
          } else {
            GameIcon = Text;
            iconColor = "text-emerald-500";
          }
          
          // Determine background color based on game type
          let bgColor;
          if (game.id === "memory-match") {
            bgColor = "hover:bg-amber-500/10";
          } else if (game.id === "quick-math") {
            bgColor = "hover:bg-blue-500/10";
          } else {
            bgColor = "hover:bg-emerald-500/10";
          }
          
          return (
            <Button 
              key={game.id}
              variant="outline" 
              onClick={() => onPlayGame(game)}
              className={`group relative flex-1 min-w-[120px] py-3 px-4 h-auto flex flex-col items-center justify-center gap-2 
                          bg-background ${bgColor} border shadow-sm hover:shadow-md transition-all duration-200`}
            >
              <div className={`p-2 rounded-full ${iconColor} bg-background/80 border group-hover:scale-110 transition-transform`}>
                <GameIcon className="h-4 w-4" />
              </div>
              <span className="font-medium text-sm">{game.name}</span>
              <span className={`absolute top-1.5 right-1.5 text-[10px] px-2 py-0.5 rounded-full 
                                ${game.difficulty === "Easy" ? "bg-green-100 text-green-700" : 
                                  "bg-amber-100 text-amber-700"} dark:bg-opacity-20`}>
                {game.difficulty}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default BrainBreaks;
